import React from 'react';
import { useParams } from 'react-router-dom';
import SystemEmailDetailComponent from '../../../components/Admin/emails/SystemEmailDetailComponent';

const SystemEmailEdit = () => {
    const params = useParams()
    return <SystemEmailDetailComponent emailId={ params.emailId } />;
}

export default SystemEmailEdit;